const DB_NAME = "selfcertify_cache";
const DB_VERSION = 1;
const STORE_NAME = "schemas";
const CATALOG_KEY = "certificates_catalog";
const API = process.env.REACT_APP_BACKEND_URL;

function openCacheDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "key" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function setCache(key, data) {
  const db = await openCacheDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    tx.objectStore(STORE_NAME).put({ key, data, cachedAt: new Date().toISOString() });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

async function getCache(key) {
  const db = await openCacheDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const req = tx.objectStore(STORE_NAME).get(key);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
}

/**
 * Fetch the certificate catalog from the API and cache it locally.
 * Falls back to cached version when offline.
 */
export async function fetchAndCacheCatalog() {
  try {
    const res = await fetch(`${API}/api/certificates/catalog`);
    if (res.ok) {
      const data = await res.json();
      await setCache(CATALOG_KEY, data);
      return data;
    }
  } catch {
    // Offline or network error — fall through to cache
  }
  // Fallback to cached
  const cached = await getCache(CATALOG_KEY);
  return cached?.data || null;
}

/**
 * Get cached catalog without network request.
 */
export async function getCachedCatalog() {
  const cached = await getCache(CATALOG_KEY);
  return cached?.data || null;
}

/**
 * Get a specific certificate schema by ID from cached catalog.
 */
export async function getCachedSchema(certId) {
  const catalog = await getCachedCatalog();
  if (!catalog?.certificates) return null;
  return catalog.certificates.find((c) => c.id === certId) || null;
}

/**
 * Get the cache timestamp.
 */
export async function getCacheAge() {
  const cached = await getCache(CATALOG_KEY);
  if (!cached?.cachedAt) return null;
  return cached.cachedAt;
}
